import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { isNotLoginLogin, rolUser } from '../../utils/session';




const moment = require("moment");

const TpvRoute = ({ component: Component, ...rest }) => {

  interface TokenInfo {
    exp: number;
  }


  const isLoggedNotIn = isNotLoginLogin();
  const isAdmin = rolUser() == 'STAFF';

  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedNotIn && isAdmin? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

export default TpvRoute